import { Box } from 'grommet'
import styled, { css } from 'styled-components'

export const Wrapper = styled(Box)`
  align-items: center;
  display: flex;
  height: 780px;
  position: relative;
  transition: transform 0.3s;
  width: 100%;
  z-index: 1;

  img {
    object-fit: cover;
    object-position: 75% 0;
  }

  &:hover {
    cursor: pointer;
    ${({ theme, hover }) => theme.above.laptopM`
      ${hover && 'transform: scale(1.1);'}
      z-index: 2;
    `}
  }

  ${({ theme }) => theme.below.laptopL`
    height: 560px;
  `}

  &:nth-child(2) > div > div {
    ${({ theme }) => theme.below.tabletS`
      white-space: normal;
    `}
  }
`

export const Container = styled(Box)`
  padding: 0 5%;
  position: absolute;
  width: 100%;
  z-index: 2;

  ${({ theme, spacing }) => css`
    & > div:not(:last-child) {
      margin-bottom: ${spacing || theme.newSpaces.md}px;
    }
  `}
`

export const Overlay = styled.div`
  background: rgba(27, 27, 27, 1);
  background: linear-gradient(
    0deg,
    ${({ textColor }) =>
        textColor !== 'black' ? 'rgba(27,27,27,1)' : 'rgba(255,255,255,1)'}
      0%,
    ${({ textColor }) =>
        textColor !== 'black' ? 'rgba(27,27,27,0.7)' : 'rgba(255,255,255,0.7)'}
      80%,
    ${({ textColor }) =>
        textColor !== 'black' ? 'rgba(27,27,27,0)' : 'rgba(255,255,255,0)'}
      100%
  );
  height: 100%;
  opacity: ${({ notOverlay }) => (notOverlay ? '0' : '0.6')};
  width: 100%;
  z-index: 1;
`
